import {TransportTypesType} from "@SearchResults/types/TransportTypes.type";
import {RoutesOrganizedByTransportTypeType} from "@SearchResults/types/RoutesOrganizedByTransportType.type";
import RouteType from "@Route/types/Route.type";
import median from "@Array/median";

export default function getCheapestAndPriciestVehClassesInGeneral(transportTypes: TransportTypesType[], singleRoutes: RoutesOrganizedByTransportTypeType) {
    let tempCheapest: number
    let tempPriciest: number
    let cheapestInGeneralTransportType: TransportTypesType
    let priciestInGeneralTransportType: TransportTypesType

    transportTypes.map((transportType) => {
        const allPrices: number[] = singleRoutes[transportType].map((route: RouteType) => (
            route.prices.priceWithDiscount["1"]["1"]
        ))

        const priceMedian = median(allPrices)

        if (!tempCheapest || tempCheapest > priceMedian) {
            tempCheapest = priceMedian
            cheapestInGeneralTransportType = transportType
        }

        if (!tempPriciest || tempPriciest < priceMedian) {
            tempPriciest = priceMedian
            priciestInGeneralTransportType = transportType
        }
    })
    return {
        cheapestInGeneralTransportType,
        priciestInGeneralTransportType,
    }
}